import { Corpus__get_MetadataQuickView, Corpus__get_MetadataMenu, Corpus__get_MetadataTable, ListOrIntervalMode, Corpus__get_SharedInfo } from "../Model/Model.js";
import { fromBits, toNumber, toString, equals } from "../../fable_modules/fable-library.3.7.9/Long.js";
import { FixedSizeList } from "react-window";
import { useReact_useEffectOnce_3A5B6456, useReact_useElementRef, React_useStateWithUpdater_1505, useReact_useEffect_Z101E1A95, useReact_useInputRef, useFeliz_React__React_useState_Static_1505 } from "../../fable_modules/Feliz.1.64.0/React.fs.js";
import { zip, toArray as toArray_1, collect, map, empty, singleton, append, delay, toList, iterate } from "../../fable_modules/fable-library.3.7.9/Seq.js";
import { map as map_1, bind, defaultArg, toArray } from "../../fable_modules/fable-library.3.7.9/Option.js";
import { createElement } from "react";
import * as react from "react";
import { Metadata_SortInfo, Metadata_SortDirection, ExternalTool, SharedCorpusInfo__HasAttribute_Z721C83C5, Metadata_LongTextCategory, Metadata_NumberCategory, Metadata_StringCategory, StringUtils_truncate, Metadata_CategoryMenuOption, Metadata_Category__get_Name, Metadata_CategorySelection_get_Default, Metadata_Category__GetQualifiedColumnName } from "../../Shared/Shared.js";
import { FSharpMap__Add, FSharpMap__get_Item, ofList, FSharpMap__TryFind } from "../../fable_modules/fable-library.3.7.9/Map.js";
import { disposeSafe, getEnumerator, safeHash, equals as equals_1, createObj } from "../../fable_modules/fable-library.3.7.9/Util.js";
import { pick, find, mapIndexed, empty as empty_1, append as append_1, contains as contains_1, map as map_2, cons, ofArray, singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.9/List.js";
import { Msg } from "./Update.js";
import { isNullOrWhiteSpace, join } from "../../fable_modules/fable-library.3.7.9/String.js";
import { Interop_reactApi } from "../../fable_modules/Feliz.1.64.0/Interop.fs.js";
import { Helpers_extractClasses, Helpers_combineClasses } from "../../fable_modules/Feliz.Bulma.2.18.0/ElementBuilders.fs.js";
import { tryPick, contains } from "../../fable_modules/fable-library.3.7.9/Array.js";
import { PropHelpers_createOnKey } from "../../fable_modules/Feliz.1.64.0/Properties.fs.js";
import { key_enter } from "../../fable_modules/Feliz.1.64.0/Key.fs.js";
import { LoadedCorpus_Msg } from "../Update.js";
import { createPortal } from "react-dom";
import { fromTicks } from "../../fable_modules/fable-library.3.7.9/TimeSpan.js";
import { toString as toString_1 } from "../../fable_modules/fable-library.3.7.9/Types.js";
import Meta from "../../../react_components/metadata_geo_map/Meta.jsx";

export function textAndTokenCountText(model) {
    const corpusInfo = Corpus__get_SharedInfo(model.Corpus);
    const matchValue = [model.NumSelectedTexts, model.NumSelectedTokens];
    let pattern_matching_result, selectedTexts_1, selectedTokens_1;
    if (matchValue[0] != null) {
        if (!equals(matchValue[0], corpusInfo.TotalTexts)) {
            pattern_matching_result = 0;
            selectedTexts_1 = matchValue[0];
            selectedTokens_1 = matchValue[1];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return `${selectedTexts_1} of ${corpusInfo.TotalTexts} ${corpusInfo.TextsReferral} (${selectedTokens_1}
          of ${corpusInfo.TotalTokens} tokens) selected ${model.TextSelectionInfo}`;
        }
        case 1: {
            return `All ${corpusInfo.TotalTexts} ${corpusInfo.TextsReferral} (${corpusInfo.TotalTokens} tokens) selected ${model.TextSelectionInfo}`;
        }
    }
}

export function MetadataGeoMap(metadataGeoMapInputProps) {
    return null;
}

export const MetadataMenu_FixedSizeList = FixedSizeList;

export function MetadataMenu_MetadataSelect(metadataMenu_MetadataSelectInputProps) {
    const dispatch = metadataMenu_MetadataSelectInputProps.dispatch;
    const isInSidebar = metadataMenu_MetadataSelectInputProps.isInSidebar;
    const fetchedMetadataValues = metadataMenu_MetadataSelectInputProps.fetchedMetadataValues;
    const metadataSelection = metadataMenu_MetadataSelectInputProps.metadataSelection;
    const isOpen = metadataMenu_MetadataSelectInputProps.isOpen;
    const category = metadataMenu_MetadataSelectInputProps.category;
    const patternInput = useFeliz_React__React_useState_Static_1505("");
    const setFilterInputText = patternInput[1];
    const filterInputText = patternInput[0];
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(1);
    const filterInputRef = useReact_useInputRef();
    const focusFilterInput = () => {
        iterate((inputFilterElement) => {
            inputFilterElement.focus();
        }, toArray(filterInputRef.current));
    };
    const reactBare = react;
    const tableAndColumn = Metadata_Category__GetQualifiedColumnName(category);
    const categorySelection_1 = defaultArg(FSharpMap__TryFind(metadataSelection, tableAndColumn), Metadata_CategorySelection_get_Default());
    useReact_useEffect_Z101E1A95(() => {
        if (isOpen) {
            focusFilterInput();
        }
    }, [isOpen]);
    const children_2 = toList(delay(() => append(isInSidebar ? singleton(createElement("a", createObj(toList(delay(() => append(singleton(["key", tableAndColumn]), delay(() => {
        let properties_2;
        return append(isOpen ? singleton((properties_2 = singleton_1(["lineHeight", 1.7 + "em"]), ["style", createObj(properties_2)])) : empty(), delay(() => append(singleton(["onClick", (_arg2) => {
            dispatch(new Msg(2, category));
        }]), delay(() => {
            let elems_4;
            return singleton((elems_4 = toList(delay(() => append(singleton(Metadata_Category__get_Name(category)), delay(() => {
                let props_4;
                return (isOpen ? true : (categorySelection_1.Choices.length > 0)) ? append(singleton((props_4 = toList(delay(() => append(singleton(["className", "is-small"]), delay(() => append(categorySelection_1.ShouldExclude ? singleton(["className", "is-danger"]) : empty(), delay(() => append(singleton(["title", "Exclude selected values"]), delay(() => append(singleton(["style", {
                    marginBottom: 5,
                    marginLeft: 10,
                }]), delay(() => append(singleton(["onClick", (e) => {
                    dispatch(new Msg(11, category));
                    e.stopPropagation();
                }]), delay(() => {
                    let elems_1, elms;
                    return singleton((elems_1 = [(elms = singleton_1(createElement("i", {
                        className: join(" ", ["fa fa-minus"]),
                    })), createElement("span", {
                        className: "icon",
                        children: Interop_reactApi.Children.toArray(Array.from(elms)),
                    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))]));
                })))))))))))), createElement("button", createObj(Helpers_combineClasses("button", props_4))))), delay(() => {
                    let props_8, elems_3, elms_1;
                    return singleton((props_8 = ofArray([["className", "is-small"], ["className", "is-danger"], ["style", {
                        marginLeft: 5,
                    }], ["title", "Remove selection"], ["onClick", (_arg3) => {
                        dispatch(new Msg(15, category));
                    }], (elems_3 = [(elms_1 = singleton_1(createElement("i", {
                        className: "fa fa-times",
                    })), createElement("span", {
                        className: "icon",
                        children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
                    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])]), createElement("button", createObj(Helpers_combineClasses("button", props_8)))));
                })) : empty();
            })))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))]));
        }))));
    }))))))) : empty(), delay(() => {
        let properties_18, elems_7;
        const choices = toList(delay(() => map((choice) => createElement("div", createObj(toList(delay(() => append(singleton(["className", "metadata-choice"]), delay(() => append(categorySelection_1.ShouldExclude ? singleton(["style", {
            color: "white",
            backgroundColor: "#f14668",
        }]) : empty(), delay(() => {
            let elems_6;
            return singleton((elems_6 = [createElement("span", createObj(toList(delay(() => append(singleton(["className", "metadata-choice-cross"]), delay(() => append(categorySelection_1.ShouldExclude ? singleton(["style", {
                color: "white",
            }]) : empty(), delay(() => {
                let elems_5;
                return singleton((elems_5 = [createElement("span", {
                    onClick: (_arg4) => {
                        dispatch(new Msg(13, category, choice));
                    },
                    children: "x",
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))]));
            })))))))), createElement("span", {
                children: choice.Name,
                title: choice.Name,
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))]));
        })))))))), categorySelection_1.Choices)));
        let filterInput;
        const props_15 = ofArray([["ref", filterInputRef], ["autoCapitalize", "off"], ["autoComplete", "off"], (properties_18 = ofArray([["width", ((patternInput_1[0] + 3) * 0.55) + "em"], ["backgroundColor", "transparent"], ["borderWidth", 0], ["boxShadow", (((0 + "px ") + 0) + "px ") + "transparent"], ["outlineWidth", 0 + "px"], ["padding", 0]]), ["style", createObj(properties_18)]), ["value", filterInputText], ["onChange", (ev) => {
            const s_1 = ev.target.value;
            setFilterInputText(s_1);
            patternInput_1[1](s_1.length);
        }]]);
        filterInput = createElement("input", createObj(cons(["type", "search"], Helpers_combineClasses("input", props_15))));
        return append((isOpen ? true : (categorySelection_1.Choices.length > 0)) ? singleton(createElement("div", createObj(ofArray([["className", "metadata-menu-selection"], ["onClick", (_arg5) => {
            setFilterInputText("");
            focusFilterInput();
            dispatch(new Msg(0, category));
        }], (elems_7 = toList(delay(() => append(choices, delay(() => (isInSidebar ? singleton(filterInput) : empty()))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])])))) : empty(), delay(() => {
            let elems_8, fetchedMetadataValues_1, selectOptions, downCasedFilterText, categorySelection;
            return isOpen ? singleton(createElement("div", createObj(ofArray([["className", "metadata-menu-list-container"], (elems_8 = [(fetchedMetadataValues_1 = ((selectOptions = fetchedMetadataValues, isNullOrWhiteSpace(filterInputText) ? selectOptions : ((downCasedFilterText = filterInputText.toLocaleLowerCase(), selectOptions.filter((option_1) => (option_1.toLocaleLowerCase().indexOf(downCasedFilterText) >= 0)))))), (categorySelection = categorySelection_1, reactBare.createElement(MetadataMenu_FixedSizeList, {
                height: 200,
                itemCount: fetchedMetadataValues_1.length,
                itemSize: 32,
            }, ((props) => {
                let properties;
                const metadataValue = fetchedMetadataValues_1[props.index];
                const selectOption = new Metadata_CategoryMenuOption(metadataValue, metadataValue);
                const isAlreadySelected = contains(selectOption, categorySelection.Choices, {
                    Equals: equals_1,
                    GetHashCode: safeHash,
                });
                return createElement("div", createObj(ofArray([["className", "metadata-menu-list-item"], (properties = toList(delay(() => append(singleton(["height", props.style.height]), delay(() => append(singleton(["left", props.style.left]), delay(() => append(singleton(["position", "absolute"]), delay(() => append(singleton(["top", props.style.top]), delay(() => append(singleton(["width", 100 + "%"]), delay(() => append(singleton(["padding", 6]), delay(() => (isAlreadySelected ? (categorySelection.ShouldExclude ? append(singleton(["color", "white"]), delay(() => singleton(["backgroundColor", "#f14668"]))) : singleton(["backgroundColor", "#ddd"])) : empty()))))))))))))))), ["style", createObj(properties)]), ["onClick", (_arg1) => {
                    setFilterInputText("");
                    dispatch(new Msg(12, category, selectOption));
                }], ["children", StringUtils_truncate(25, selectOption.Name)], ["title", selectOption.Name]])));
            }))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))])])))) : empty();
        }));
    }))));
    return createElement("li", {
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    });
}

export function MetadataMenu_stringSelect(category, isOpen, metadataSelection, fetchedMetadataValues, isInSidebar, dispatch) {
    return createElement(MetadataMenu_MetadataSelect, {
        category: category,
        isOpen: isOpen,
        metadataSelection: metadataSelection,
        fetchedMetadataValues: fetchedMetadataValues,
        isInSidebar: isInSidebar,
        dispatch: dispatch,
    });
}

export function MetadataMenu_numberSelect(category, isOpen, metadataSelection, fetchedMetadataValues, isInSidebar, dispatch) {
    return createElement(MetadataMenu_MetadataSelect, {
        category: category,
        isOpen: isOpen,
        metadataSelection: metadataSelection,
        fetchedMetadataValues: fetchedMetadataValues,
        isInSidebar: isInSidebar,
        dispatch: dispatch,
    });
}

export function MetadataMenu_SelectOrInterval(metadataMenu_SelectOrIntervalInputProps) {
    const dispatch = metadataMenu_SelectOrIntervalInputProps.dispatch;
    const isInSidebar = metadataMenu_SelectOrIntervalInputProps.isInSidebar;
    const fetchedMinAndMax = metadataMenu_SelectOrIntervalInputProps.fetchedMinAndMax;
    const fetchedMetadataValues = metadataMenu_SelectOrIntervalInputProps.fetchedMetadataValues;
    const metadataSelection = metadataMenu_SelectOrIntervalInputProps.metadataSelection;
    const mode = metadataMenu_SelectOrIntervalInputProps.mode;
    const isOpen = metadataMenu_SelectOrIntervalInputProps.isOpen;
    const category = metadataMenu_SelectOrIntervalInputProps.category;
    const catCode = Metadata_Category__GetQualifiedColumnName(category);
    const maybeCategorySelection = FSharpMap__TryFind(metadataSelection, catCode);
    const pickValue = (choiceName) => bind((categorySelection) => tryPick((choice) => {
        if (choice.Name === choiceName) {
            return choice.Value;
        }
        else {
            return void 0;
        }
    }, categorySelection.Choices), maybeCategorySelection);
    const maybeFrom = pickValue("app_interval_from");
    const maybeTo = pickValue("app_interval_to");
    const intervalStateFromProps = ofList(ofArray([["From:", maybeFrom], ["To:", maybeTo]]));
    const patternInput = React_useStateWithUpdater_1505(intervalStateFromProps);
    const setIntervalState = patternInput[1];
    const intervalState = patternInput[0];
    useReact_useEffect_Z101E1A95(() => {
        setIntervalState((_arg1) => intervalStateFromProps);
    }, [isOpen]);
    const submitChanges = (label, onChangeMsg) => {
        const matchValue = FSharpMap__get_Item(intervalState, label);
        if (matchValue == null) {
        }
        else {
            dispatch(onChangeMsg([category, matchValue]));
            dispatch(new Msg(9));
        }
    };
    const hasChanged = (label_1) => {
        if (label_1 === "From:") {
            return !equals_1(FSharpMap__get_Item(intervalState, "From:"), maybeFrom);
        }
        else {
            return !equals_1(FSharpMap__get_Item(intervalState, "To:"), maybeTo);
        }
    };
    let interval;
    const boundaryInput = (label_2, maybeValue, mixOrMaxSelectionFunction, onChangeMsg_1) => {
        let children_2, props_10, elems_3;
        let textInput;
        const props = ofArray([["placeholder", defaultArg(map_1((arg) => toString(mixOrMaxSelectionFunction(arg)), fetchedMinAndMax), "")], ["value", defaultArg(maybeValue, "")], ["onChange", (ev) => {
            const v_1 = ev.target.value;
            setIntervalState((state) => FSharpMap__Add(state, label_2, v_1));
        }], ["onKeyUp", (ev_1) => {
            PropHelpers_createOnKey(key_enter, (_arg2) => {
                submitChanges(label_2, onChangeMsg_1);
            }, ev_1);
        }]]);
        textInput = createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", props))));
        let checkButton;
        const props_4 = toList(delay(() => append(singleton(["disabled", !hasChanged(label_2)]), delay(() => append(singleton(["style", {
            width: 50,
        }]), delay(() => append(hasChanged(label_2) ? singleton(["className", "is-success"]) : empty(), delay(() => append(singleton(["onClick", (_arg3) => {
            submitChanges(label_2, onChangeMsg_1);
        }]), delay(() => {
            let elems_1, elms;
            return hasChanged(label_2) ? singleton(["children", "OK"]) : singleton((elems_1 = [(elms = singleton_1(createElement("i", {
                className: join(" ", ["fa fa-check"]),
            })), createElement("span", {
                className: "icon",
                children: Interop_reactApi.Children.toArray(Array.from(elms)),
            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))]));
        }))))))))));
        checkButton = createElement("button", createObj(Helpers_combineClasses("button", props_4)));
        const children_4 = ofArray([createElement("td", {
            style: {
                verticalAlign: "middle",
            },
            children: label_2,
        }), (children_2 = singleton_1((props_10 = ofArray([["className", "has-addons"], (elems_3 = [createElement("div", createObj(Helpers_combineClasses("control", ofArray([["className", "is-expanded"], ["children", textInput]])))), createElement("div", {
            className: "control",
            children: Interop_reactApi.Children.toArray([checkButton]),
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])]), createElement("div", createObj(Helpers_combineClasses("field", props_10))))), createElement("td", {
            children: Interop_reactApi.Children.toArray(Array.from(children_2)),
        }))]);
        return createElement("tr", {
            children: Interop_reactApi.Children.toArray(Array.from(children_4)),
        });
    };
    const children_9 = toList(delay(() => append(isInSidebar ? singleton(createElement("a", createObj(toList(delay(() => append(singleton(["key", catCode]), delay(() => {
        let properties_10;
        return append(isOpen ? singleton((properties_10 = singleton_1(["lineHeight", 1.7 + "em"]), ["style", createObj(properties_10)])) : empty(), delay(() => append(singleton(["onClick", (_arg4) => {
            dispatch(new Msg(6, category));
        }]), delay(() => {
            let elems_6;
            return singleton((elems_6 = toList(delay(() => append(singleton(Metadata_Category__get_Name(category)), delay(() => {
                let props_16, elems_5, elms_2;
                return isOpen ? singleton((props_16 = ofArray([["className", "is-small"], ["className", "is-danger"], ["style", {
                    marginLeft: 15,
                }], ["title", "Remove selection"], ["onClick", (_arg5) => {
                    dispatch(new Msg(15, category));
                }], (elems_5 = [(elms_2 = singleton_1(createElement("i", {
                    className: "fa fa-times",
                })), createElement("span", {
                    className: "icon",
                    children: Interop_reactApi.Children.toArray(Array.from(elms_2)),
                }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])]), createElement("button", createObj(Helpers_combineClasses("button", props_16))))) : empty();
            })))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))]));
        }))));
    }))))))) : empty(), delay(() => {
        let children_7, properties_18;
        if (isOpen) {
            return singleton(createElement("table", {
                className: "interval-category-table",
                style: {
                    marginTop: 5,
                    marginBottom: 5,
                    marginLeft: 10,
                },
                children: (children_7 = ofArray([boundaryInput("From:", FSharpMap__get_Item(intervalState, "From:"), (tuple) => tuple[0], (tupledArg) => (new Msg(16, tupledArg[0], tupledArg[1]))), boundaryInput("To:", FSharpMap__get_Item(intervalState, "To:"), (tuple_1) => tuple_1[1], (tupledArg_1) => (new Msg(17, tupledArg_1[0], tupledArg_1[1])))]), createElement("tbody", {
                    children: Interop_reactApi.Children.toArray(Array.from(children_7)),
                })),
            }));
        }
        else {
            const fromText = defaultArg(maybeFrom, "");
            const toText = defaultArg(maybeTo, "");
            return ((fromText !== "") ? true : (toText !== "")) ? singleton(createElement("div", createObj(ofArray([["className", "selected-interval"], (properties_18 = toList(delay(() => append(isInSidebar ? singleton(["paddingLeft", 30]) : empty(), delay(() => append(singleton(["paddingBottom", 10]), delay(() => append(singleton(["fontSize", 12 + "px"]), delay(() => append(singleton(["cursor", "pointer"]), delay(() => singleton(["whiteSpace", "nowrap"]))))))))))), ["style", createObj(properties_18)]), ["onClick", (_arg6) => {
                dispatch(new Msg(0, category));
            }], ["children", `${fromText} â ${toText}`]])))) : empty();
        }
    }))));
    interval = createElement("li", {
        children: Interop_reactApi.Children.toArray(Array.from(children_9)),
    });
    const children_17 = toList(delay(() => append(equals_1(mode, new ListOrIntervalMode(0)) ? singleton(MetadataMenu_numberSelect(category, isOpen, metadataSelection, fetchedMetadataValues, isInSidebar, dispatch)) : singleton(interval), delay(() => {
        let props_30, elems_9;
        if (isOpen) {
            const listButton = createElement("li", createObj(toList(delay(() => append(equals_1(mode, new ListOrIntervalMode(0)) ? singleton(["className", "is-active"]) : empty(), delay(() => append(singleton(["onClick", (_arg7) => {
                if (!equals_1(mode, new ListOrIntervalMode(0))) {
                    dispatch(new Msg(15, category));
                    dispatch(new Msg(4, category));
                    dispatch(new Msg(3, category, new ListOrIntervalMode(0)));
                }
            }]), delay(() => {
                let elems_7, children_11;
                return singleton((elems_7 = [(children_11 = singleton_1(createElement("span", {
                    children: ["List"],
                })), createElement("a", {
                    children: Interop_reactApi.Children.toArray(Array.from(children_11)),
                }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))]));
            }))))))));
            const intervalButton = createElement("li", createObj(toList(delay(() => append(equals_1(mode, new ListOrIntervalMode(1)) ? singleton(["className", "is-active"]) : empty(), delay(() => append(singleton(["onClick", (_arg9) => {
                if (!equals_1(mode, new ListOrIntervalMode(1))) {
                    setIntervalState((_arg8) => intervalStateFromProps);
                    dispatch(new Msg(15, category));
                    dispatch(new Msg(7, category));
                    dispatch(new Msg(3, category, new ListOrIntervalMode(1)));
                }
            }]), delay(() => {
                let elems_8, children_13;
                return singleton((elems_8 = [(children_13 = singleton_1(createElement("span", {
                    children: ["Interval"],
                })), createElement("a", {
                    children: Interop_reactApi.Children.toArray(Array.from(children_13)),
                }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))]));
            }))))))));
            return singleton((props_30 = ofArray([["className", "is-toggle"], ["className", "is-small"], ["className", "is-centered"], ["style", {
                marginTop: 5,
            }], (elems_9 = [createElement("ul", {
                children: Interop_reactApi.Children.toArray([listButton, intervalButton]),
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])]), createElement("div", createObj(Helpers_combineClasses("tabs", props_30)))));
        }
        else {
            return empty();
        }
    }))));
    return createElement("span", {
        children: Interop_reactApi.Children.toArray(Array.from(children_17)),
    });
}

export function MetadataMenu_freeTextSearch(category, dispatch) {
    const catCode = Metadata_Category__GetQualifiedColumnName(category);
    const value_5 = createElement("a", {
        key: catCode,
        children: Metadata_Category__get_Name(category),
        onClick: (_arg1) => {
            dispatch(new Msg(2, category));
        },
    });
    return createElement("li", {
        children: [value_5],
    });
}

export function MetadataMenu_Section(metadataMenu_SectionInputProps) {
    const dispatch = metadataMenu_SectionInputProps.dispatch;
    const fetchedMinAndMax = metadataMenu_SectionInputProps.fetchedMinAndMax;
    const fetchedMetadataValues = metadataMenu_SectionInputProps.fetchedMetadataValues;
    const metadataSelection = metadataMenu_SectionInputProps.metadataSelection;
    const intervalCategoryModes = metadataMenu_SectionInputProps.intervalCategoryModes;
    const openCategoryCode = metadataMenu_SectionInputProps.openCategoryCode;
    const items = metadataMenu_SectionInputProps.items;
    const title = metadataMenu_SectionInputProps.title;
    const patternInput = useFeliz_React__React_useState_Static_1505(metadataMenu_SectionInputProps.startExpanded);
    const isExpanded = patternInput[0];
    const children = map_2((item) => {
        if (item.tag === 0) {
            const cat = item.fields[0];
            const isOpen = equals_1(cat["Shared.Metadata.Category.get_Code"](), openCategoryCode);
            if (cat instanceof Metadata_StringCategory) {
                return MetadataMenu_stringSelect(cat, isOpen, metadataSelection, fetchedMetadataValues, true, dispatch);
            }
            else if (cat instanceof Metadata_NumberCategory) {
                return createElement(MetadataMenu_SelectOrInterval, {
                    category: cat,
                    isOpen: isOpen,
                    mode: defaultArg(FSharpMap__TryFind(intervalCategoryModes, cat["Shared.Metadata.Category.get_Code"]()), new ListOrIntervalMode(0)),
                    metadataSelection: metadataSelection,
                    fetchedMetadataValues: fetchedMetadataValues,
                    fetchedMinAndMax: fetchedMinAndMax,
                    isInSidebar: true,
                    dispatch: dispatch,
                });
            }
            else if (cat instanceof Metadata_LongTextCategory) {
                return MetadataMenu_freeTextSearch(cat, dispatch);
            }
            else {
                throw (new Error(`Unhandled category: ${cat}`));
            }
        }
        else {
            throw (new Error(`Sections are not allowed as children of other sections: ${item}`));
        }
    }, items);
    const children_2 = toList(delay(() => {
        let props_2, elems_1, elms;
        return append((title !== "") ? singleton((props_2 = ofArray([["style", {
            cursor: "pointer",
            marginTop: 10,
            marginBottom: 0,
        }], ["onClick", (_arg1) => {
            patternInput[1](!isExpanded);
        }], (elems_1 = [title, (elms = singleton_1(createElement("i", {
            className: join(" ", toList(delay(() => append(singleton("fa"), delay(() => (isExpanded ? singleton("fa-angle-up") : singleton("fa-angle-down"))))))),
        })), createElement("span", {
            className: "icon",
            children: Interop_reactApi.Children.toArray(Array.from(elms)),
        }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]), createElement("p", createObj(Helpers_combineClasses("menu-label", props_2))))) : empty(), delay(() => {
            let properties_4;
            return isExpanded ? singleton(createElement("ul", createObj(ofArray([["className", "menu-list"], (properties_4 = ofArray([["border", (((2 + "px ") + "solid") + " ") + "#0090d6"], ["borderRadius", 5], ["marginTop", 5], ["padding", 5]]), ["style", createObj(properties_4)]), ["children", Interop_reactApi.Children.toArray(Array.from(children))]])))) : empty();
        }));
    }));
    return createElement("span", {
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    });
}

export function MetadataMenu_SelectionTablePopup(metadataMenu_SelectionTablePopupInputProps) {
    let value, matchValue, elms, elems_6, elems_5, elems_12, elms_2, children_16, children_14, s, elms_3, children_27, props_78, elems_28, elms_8, children_38, props_84, properties_66;
    const dispatch = metadataMenu_SelectionTablePopupInputProps.dispatch;
    const loadedCorpusDispatch = metadataMenu_SelectionTablePopupInputProps.loadedCorpusDispatch;
    const model = metadataMenu_SelectionTablePopupInputProps.model;
    let pagination;
    const pageSize = 50;
    const numPages = (~(~((value = ((matchValue = model.NumSelectedTexts, (matchValue == null) ? (toNumber(Corpus__get_SharedInfo(model.Corpus).TotalTexts) / pageSize) : (toNumber(matchValue) / pageSize))), Math.ceil(value))))) | 0;
    const setPage = (e, pageNo) => {
        e.preventDefault();
        if ((pageNo >= 1) && (pageNo <= numPages)) {
            dispatch(new Msg(20, pageNo));
        }
    };
    const children_11 = singleton_1((elms = toList(delay(() => {
        let children;
        return append((model.SelectionTablePageNumber > 1) ? singleton((children = singleton_1(createElement("a", createObj(Helpers_combineClasses("pagination-link", ofArray([["onClick", (e_1) => {
            setPage(e_1, 1);
        }], ["children", "1"]]))))), createElement("li", {
            children: Interop_reactApi.Children.toArray(Array.from(children)),
        }))) : empty(), delay(() => {
            let elems;
            return append((model.SelectionTablePageNumber >= 4) ? singleton(createElement("li", createObj(ofArray([["key", "ellipse-left"], (elems = [createElement("span", {
                className: "pagination-ellipsis",
                children: "â¦",
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))) : empty(), delay(() => {
                let props_5, children_2;
                return append((model.SelectionTablePageNumber >= 3) ? singleton((props_5 = ofArray([["onClick", (e_2) => {
                    setPage(e_2, model.SelectionTablePageNumber - 1);
                }], ["children", model.SelectionTablePageNumber - 1]]), (children_2 = singleton_1(createElement("a", createObj(Helpers_combineClasses("pagination-link", props_5)))), createElement("li", {
                    children: Interop_reactApi.Children.toArray(Array.from(children_2)),
                })))) : empty(), delay(() => {
                    let children_4;
                    return append(singleton((children_4 = singleton_1(createElement("a", createObj(Helpers_combineClasses("pagination-link", ofArray([["className", "is-current"], ["children", model.SelectionTablePageNumber]]))))), createElement("li", {
                        children: Interop_reactApi.Children.toArray(Array.from(children_4)),
                    }))), delay(() => {
                        let props_11, children_6;
                        return append((model.SelectionTablePageNumber <= (numPages - 2)) ? singleton((props_11 = ofArray([["onClick", (e_3) => {
                            setPage(e_3, model.SelectionTablePageNumber + 1);
                        }], ["children", model.SelectionTablePageNumber + 1]]), (children_6 = singleton_1(createElement("a", createObj(Helpers_combineClasses("pagination-link", props_11)))), createElement("li", {
                            children: Interop_reactApi.Children.toArray(Array.from(children_6)),
                        })))) : empty(), delay(() => {
                            let elems_1;
                            return append((model.SelectionTablePageNumber <= (numPages - 3)) ? singleton(createElement("li", createObj(ofArray([["key", "ellipse-right"], (elems_1 = [createElement("span", {
                                className: "pagination-ellipsis",
                                children: "â¦",
                            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))) : empty(), delay(() => {
                                let children_8;
                                return (model.SelectionTablePageNumber < numPages) ? singleton((children_8 = singleton_1(createElement("a", createObj(Helpers_combineClasses("pagination-link", ofArray([["onClick", (e_4) => {
                                    setPage(e_4, numPages);
                                }], ["children", numPages]]))))), createElement("li", {
                                    children: Interop_reactApi.Children.toArray(Array.from(children_8)),
                                }))) : empty();
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })), createElement("ul", {
        className: "pagination-list",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    })));
    pagination = createElement("nav", {
        className: "pagination",
        children: Interop_reactApi.Children.toArray(Array.from(children_11)),
    });
    let header;
    let voyant;
    let buttons;
    const info = Corpus__get_SharedInfo(model.Corpus);
    const elms_1 = toList(delay(() => {
        let props_21;
        return append(singleton((props_21 = ofArray([["className", "is-success"], ["onClick", (_arg1) => {
            dispatch(new Msg(26, "word"));
        }], ["children", SharedCorpusInfo__HasAttribute_Z721C83C5(info, "phon") ? "Orthographic" : (SharedCorpusInfo__HasAttribute_Z721C83C5(info, "orig") ? "Corrected" : "Word form")]]), createElement("button", createObj(Helpers_combineClasses("button", props_21))))), delay(() => append(SharedCorpusInfo__HasAttribute_Z721C83C5(info, "phon") ? singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["onClick", (_arg2) => {
            dispatch(new Msg(26, "phon"));
        }], ["children", "Phonetic"]]))))) : empty(), delay(() => append(SharedCorpusInfo__HasAttribute_Z721C83C5(info, "orig") ? singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["onClick", (_arg3) => {
            dispatch(new Msg(26, "orig"));
        }], ["children", "Original"]]))))) : empty(), delay(() => (SharedCorpusInfo__HasAttribute_Z721C83C5(info, "lemma") ? singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["onClick", (_arg4) => {
            dispatch(new Msg(26, "lemma"));
        }], ["children", "Lemmas"]]))))) : empty())))))));
    }));
    buttons = createElement("div", {
        className: "buttons",
        children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
    });
    const props_33 = ofArray([["style", {
        marginRight: 50,
    }], (elems_6 = [createElement("span", createObj(ofArray([["style", {
        marginRight: 10,
    }], (elems_5 = [createElement("span", {
        children: ["Open in "],
    }), createElement("a", {
        href: "https://voyant-tools.org/",
        target: "_blank",
        children: "Voyant:",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])]))), buttons], ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])]);
    voyant = createElement("div", createObj(Helpers_combineClasses("level-item", props_33)));
    const props_47 = ofArray([["style", {
        padding: 20,
        marginBottom: 0,
    }], (elems_12 = [(elms_2 = singleton_1((children_16 = singleton_1((children_14 = ofArray([(s = textAndTokenCountText(model), createElement("h2", {
        className: "subtitle",
        children: s,
    })), createElement("div", {
        style: {
            marginTop: 10,
        },
        children: createElement("h2", createObj(Helpers_combineClasses("subtitle", ofArray([["className", "is-6"], ["children", "Click on a column header to sort; alt/option + click to edit the metadata selection."]])))),
    })]), createElement("span", {
        children: Interop_reactApi.Children.toArray(Array.from(children_14)),
    }))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(children_16)),
    }))), createElement("div", {
        className: "level-left",
        children: Interop_reactApi.Children.toArray(Array.from(elms_2)),
    })), (elms_3 = toList(delay(() => append(contains_1(new ExternalTool(2), Corpus__get_SharedInfo(model.Corpus).ExternalTools, {
        Equals: equals_1,
        GetHashCode: safeHash,
    }) ? singleton(voyant) : empty(), delay(() => append(singleton(createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray([pagination]),
    })), delay(() => {
        let children_21, props_43;
        return singleton((children_21 = singleton_1((props_43 = ofArray([["className", "is-info"], ["title", "Close"], ["style", {
            marginLeft: 40,
        }], ["onClick", (_arg5) => {
            dispatch(new Msg(22));
        }], ["children", "Close"]]), createElement("button", createObj(Helpers_combineClasses("button", props_43))))), createElement("div", {
            className: "level-item",
            children: Interop_reactApi.Children.toArray(Array.from(children_21)),
        })));
    })))))), createElement("div", {
        className: "level-right",
        children: Interop_reactApi.Children.toArray(Array.from(elms_3)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_12))])]);
    header = createElement("nav", createObj(Helpers_combineClasses("level", props_47)));
    let table;
    let tableHeader;
    const children_29 = singleton_1((children_27 = append_1(ofArray([equals_1(model.Corpus["Model.Corpus.SelectionTableFirstColumnZ3081B86A"]("", Corpus__get_SharedInfo(model.Corpus)), null) ? null : createElement("th", {}), Corpus__get_SharedInfo(model.Corpus).ShowInfoBtnInSelectionPopup ? createElement("th", {}) : null]), toList(delay(() => map((category_1) => {
        let elems_18;
        const category = category_1;
        const getMenu = (showAsOpen) => {
            let properties_36, elems_15, props_56, elems_14;
            const showMenuHeader = showAsOpen;
            let menuContents;
            if (category instanceof Metadata_StringCategory) {
                menuContents = MetadataMenu_stringSelect(category, showAsOpen, model.Search.Params.MetadataSelection, model.FetchedMetadataValues, showMenuHeader, dispatch);
            }
            else if (category instanceof Metadata_NumberCategory) {
                menuContents = createElement(MetadataMenu_SelectOrInterval, {
                    category: category,
                    isOpen: showAsOpen,
                    mode: defaultArg(FSharpMap__TryFind(model.IntervalCategoryModes, category["Shared.Metadata.Category.get_Code"]()), new ListOrIntervalMode(0)),
                    metadataSelection: model.Search.Params.MetadataSelection,
                    fetchedMetadataValues: model.FetchedMetadataValues,
                    fetchedMinAndMax: model.FetchedMinAndMax,
                    isInSidebar: showMenuHeader,
                    dispatch: dispatch,
                });
            }
            else if (category instanceof Metadata_LongTextCategory) {
                menuContents = MetadataMenu_freeTextSearch(category, dispatch);
            }
            else {
                throw (new Error(`Unhandled category: ${category}`));
            }
            const closeButton = createElement("button", createObj(Helpers_combineClasses("delete", ofArray([["onClick", (e_5) => {
                e_5.stopPropagation();
                dispatch(new Msg(1));
            }], ["title", "Close"]]))));
            const menuList = createElement("ul", createObj(Helpers_combineClasses("menu-list", ofArray([["onClick", (e_6) => {
                e_6.stopPropagation();
            }], ["children", menuContents]]))));
            if (showAsOpen) {
                return createElement("div", createObj(ofArray([(properties_36 = ofArray([["position", "absolute"], ["maxWidth", 225], ["backgroundColor", "white"], ["border", ((("1px" + " ") + "solid") + " ") + "#a1a1a1"], ["borderRadius", 7], ["padding", 10], ["zIndex", 1]]), ["style", createObj(properties_36)]), (elems_15 = [(props_56 = ofArray([["style", {
                    marginBottom: 0,
                }], (elems_14 = [createElement("div", createObj(Helpers_combineClasses("level-left", empty_1()))), createElement("div", {
                    className: "level-right",
                    children: Interop_reactApi.Children.toArray([closeButton]),
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_14))])]), createElement("nav", createObj(Helpers_combineClasses("level", props_56)))), menuList], ["children", Interop_reactApi.Children.toArray(Array.from(elems_15))])])));
            }
            else {
                return menuList;
            }
        };
        const isMenuOpen = equals_1(category["Shared.Metadata.Category.get_Code"](), model.OpenMetadataCategoryCode);
        return createElement("th", createObj(ofArray([["onClick", (e_7) => {
            if (e_7.altKey) {
                e_7.stopPropagation();
                if (category instanceof Metadata_NumberCategory) {
                    dispatch(new Msg(7, category));
                }
                dispatch(new Msg(0, category));
            }
            else {
                let direction;
                const matchValue_1 = model.SelectionTableSort;
                if (matchValue_1 == null) {
                    direction = (new Metadata_SortDirection(0));
                }
                else {
                    const sortInfo = matchValue_1;
                    direction = ((sortInfo.CategoryCode === Metadata_Category__GetQualifiedColumnName(category)) ? (equals_1(sortInfo.Direction, new Metadata_SortDirection(0)) ? (new Metadata_SortDirection(1)) : (new Metadata_SortDirection(0))) : (new Metadata_SortDirection(0)));
                }
                dispatch(new Msg(21, new Metadata_SortInfo(Metadata_Category__GetQualifiedColumnName(category), direction)));
            }
        }], (elems_18 = toList(delay(() => append(isMenuOpen ? singleton(getMenu(true)) : empty(), delay(() => {
            let matchValue_2, sortInfo_2, elems_17, value_155, elms_4;
            return append((matchValue_2 = model.SelectionTableSort, (matchValue_2 != null) ? ((matchValue_2.CategoryCode === category["Shared.Metadata.Category.get_Code"]()) ? ((sortInfo_2 = matchValue_2, singleton(createElement("span", createObj(ofArray([["className", "icon-text"], (elems_17 = [(value_155 = Metadata_Category__get_Name(category), createElement("span", {
                children: [value_155],
            })), (elms_4 = singleton_1(createElement("i", {
                className: join(" ", toList(delay(() => append(singleton("fa"), delay(() => (equals_1(sortInfo_2.Direction, new Metadata_SortDirection(0)) ? singleton("fa-sort-down") : singleton("fa-sort-up"))))))),
            })), createElement("span", {
                className: "icon",
                children: Interop_reactApi.Children.toArray(Array.from(elms_4)),
            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_17))])])))))) : singleton(Metadata_Category__get_Name(category))) : singleton(Metadata_Category__get_Name(category))), delay(() => singleton(createElement("div", {
                style: {
                    marginTop: 5,
                    marginBottom: 5,
                },
                children: getMenu(false),
            }))));
        })))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_18))])])));
    }, Corpus__get_MetadataTable(model.Corpus))))), createElement("tr", {
        children: Interop_reactApi.Children.toArray(Array.from(children_27)),
    })));
    tableHeader = createElement("thead", {
        children: Interop_reactApi.Children.toArray(Array.from(children_29)),
    });
    let tableBody;
    const children_34 = toList(delay(() => collect((row) => {
        let children_32, elems_22, elems_21, props_71, elems_20, elms_5;
        const tid = row[0];
        return singleton((children_32 = append_1(ofArray([model.Corpus["Model.Corpus.SelectionTableFirstColumnZ3081B86A"](tid, Corpus__get_SharedInfo(model.Corpus)), Corpus__get_SharedInfo(model.Corpus).ShowInfoBtnInSelectionPopup ? createElement("td", createObj(ofArray([["style", {
            paddingLeft: 0,
            paddingRight: 0,
        }], (elems_22 = [createElement("a", createObj(ofArray([["href", ""], (elems_21 = [(props_71 = ofArray([["className", "is-small"], ["onClick", (e_8) => {
            e_8.preventDefault();
            loadedCorpusDispatch(new LoadedCorpus_Msg(25, model.Corpus, tid));
        }], (elems_20 = [(elms_5 = singleton_1(createElement("i", {
            className: join(" ", ["fa", "fa-info"]),
        })), createElement("span", {
            className: "icon",
            children: Interop_reactApi.Children.toArray(Array.from(elms_5)),
        }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_20))])]), createElement("button", createObj(Helpers_combineClasses("button", props_71))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_21))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_22))])]))) : null]), toList(delay(() => map((column) => createElement("td", {
            children: [column],
        }), row)))), createElement("tr", {
            children: Interop_reactApi.Children.toArray(Array.from(children_32)),
        })));
    }, model.FetchedTextMetadata)));
    tableBody = createElement("tbody", {
        children: Interop_reactApi.Children.toArray(Array.from(children_34)),
    });
    const elms_6 = singleton_1((props_78 = ofArray([["className", "is-striped"], ["className", "is-fullwidth"], ["children", Interop_reactApi.Children.toArray([tableHeader, tableBody])]]), createElement("table", createObj(Helpers_combineClasses("table", props_78)))));
    table = createElement("div", {
        className: "table-container",
        children: Interop_reactApi.Children.toArray(Array.from(elms_6)),
    });
    let footer;
    const props_88 = ofArray([["style", {
        padding: 20,
        marginBottom: 0,
    }], (elems_28 = [createElement("div", createObj(Helpers_combineClasses("level-left", empty_1()))), (elms_8 = ofArray([createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray([pagination]),
    }), (children_38 = singleton_1((props_84 = ofArray([["className", "is-info"], ["title", "Close"], ["style", {
        marginLeft: 40,
    }], ["onClick", (_arg6) => {
        dispatch(new Msg(22));
    }], ["children", "Close"]]), createElement("button", createObj(Helpers_combineClasses("button", props_84))))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(children_38)),
    }))]), createElement("div", {
        className: "level-right",
        children: Interop_reactApi.Children.toArray(Array.from(elms_8)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_28))])]);
    footer = createElement("nav", createObj(Helpers_combineClasses("level", props_88)));
    const elementRef = useReact_useElementRef();
    useReact_useEffectOnce_3A5B6456(() => {
        iterate((popupElement) => {
            popupElement.focus();
        }, toArray(elementRef.current));
    });
    return createPortal(createElement("div", createObj(ofArray([["className", "overscroll-contain"], (properties_66 = ofArray([["height", 100 + "%"], ["top", 0], ["left", 0], ["width", 100 + "%"], ["position", "absolute"], ["zIndex", 40], ["backgroundColor", "white"], ["overflowX", "hidden"], ["border", (((1 + "px ") + "solid") + " ") + "black"], ["transitionProperty", "height"], ["transitionDuration", fromTicks(fromBits(3500000, 0, false)) + "ms"], ["transitionTimingFunction", "ease-out"]]), ["style", createObj(properties_66)]), ["ref", elementRef], ["tabIndex", 0], ["onKeyUp", (e_9) => {
        if (e_9.key === "Escape") {
            dispatch(new Msg(22));
        }
    }], ["children", Interop_reactApi.Children.toArray([header, table, footer])]]))), document.getElementById("metadata-selection-popup-root"));
}

export function MetadataMenu_MetadataGeoMapModal(metadataMenu_MetadataGeoMapModalInputProps) {
    let elems_1, props_2, elems;
    const dispatch = metadataMenu_MetadataGeoMapModalInputProps.dispatch;
    const allCategories = metadataMenu_MetadataGeoMapModalInputProps.allCategories;
    const metadata = metadataMenu_MetadataGeoMapModalInputProps.metadata;
    const geoMapConfig = metadataMenu_MetadataGeoMapModalInputProps.geoMapConfig;
    const geoCoords = metadataMenu_MetadataGeoMapModalInputProps.geoCoords;
    const googleMapsApiKey = metadataMenu_MetadataGeoMapModalInputProps.googleMapsApiKey;
    const elementRef = useReact_useElementRef();
    useReact_useEffectOnce_3A5B6456(() => {
        iterate((modalElement) => {
            modalElement.focus();
        }, toArray(elementRef.current));
    });
    const coords = createObj(toArray_1(delay(() => collect((matchValue) => singleton([matchValue[0], new Float64Array([matchValue[1], matchValue[2]])]), geoCoords))));
    const config = {
        API_KEY: googleMapsApiKey,
        CATEGORY: createObj(mapIndexed((index, cat) => [cat.QualifiedColumnName, {
            CODE: cat.QualifiedColumnName,
            COLUMN: index,
            NAME: cat.Name,
            TYPE: toString_1(cat.ControlType),
        }], geoMapConfig.MetadataCategories)),
        CENTER: {
            lat: geoMapConfig.CenterLat,
            lng: geoMapConfig.CenterLng,
        },
        ID: "texts.tid",
        LOCATOR: geoMapConfig.LocationMetadataCategory.QualifiedColumnName,
        ZOOM: geoMapConfig.ZoomLevel,
    };
    const props_6 = ofArray([["className", "is-active"], ["ref", elementRef], ["tabIndex", 0], ["onKeyUp", (e) => {
        if (e.key === "Escape") {
            dispatch(new Msg(25));
        }
    }], (elems_1 = [createElement("div", createObj(Helpers_combineClasses("modal-background", singleton_1(["onClick", (_arg1) => {
        dispatch(new Msg(25));
    }])))), (props_2 = ofArray([["style", {
        width: 1440,
    }], (elems = [createElement(Meta, {
        coords: coords,
        config: config,
        meta: metadata,
        ok: (results) => {
            const enumerator = getEnumerator(zip(Object.keys(results), Object.values(results)));
            try {
                while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
                    const forLoopVar = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
                    const value = forLoopVar[1];
                    const catCode = forLoopVar[0];
                    const categoryObj = find((c) => (Metadata_Category__GetQualifiedColumnName(c) === catCode), allCategories);
                    const catControlType = pick((c_1) => {
                        if (c_1.QualifiedColumnName === catCode) {
                            return c_1.ControlType;
                        }
                        else {
                            return void 0;
                        }
                    }, geoMapConfig.MetadataCategories);
                    if (catControlType.tag === 0) {
                        dispatch(new Msg(14, categoryObj, toArray_1(delay(() => map((v) => (new Metadata_CategoryMenuOption(v, v)), value))), false));
                    }
                    else if (categoryObj instanceof Metadata_NumberCategory) {
                        const valueArray = value;
                        const min = valueArray[0];
                        const max = valueArray[1];
                        dispatch(new Msg(3, categoryObj, new ListOrIntervalMode(1)));
                        dispatch(new Msg(16, categoryObj, min));
                        dispatch(new Msg(17, categoryObj, max));
                    }
                    else {
                        throw (new Error(`Non-numerical category defined as interval: ${catCode}`));
                    }
                }
            }
            finally {
                disposeSafe(enumerator);
            }
            dispatch(new Msg(9));
            dispatch(new Msg(25));
        },
        cancel: () => {
            dispatch(new Msg(25));
        },
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]), createElement("div", createObj(Helpers_combineClasses("modal-content", props_2)))), createElement("button", createObj(Helpers_combineClasses("modal-close", ofArray([["className", "is-large"], ["onClick", (_arg2) => {
        dispatch(new Msg(25));
    }]]))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]);
    return createElement("div", createObj(Helpers_combineClasses("modal", props_6)));
}

export function MetadataMenu_view(model, loadedCorpusDispatch, dispatch) {
    let patternInput, elems_1, props_9, elems_2, elems_4, props_12, elems_3, elems_9;
    let voyantSelect;
    const info = Corpus__get_SharedInfo(model.Corpus);
    const selectOptions = toList(delay(() => append(singleton(createElement("option", {
        value: "",
        children: "Open in Voyant",
    })), delay(() => append(singleton(createElement("option", {
        value: "word",
        children: SharedCorpusInfo__HasAttribute_Z721C83C5(info, "phon") ? "Orthographic" : (SharedCorpusInfo__HasAttribute_Z721C83C5(info, "orig") ? "Corrected" : "Word form"),
    })), delay(() => append(SharedCorpusInfo__HasAttribute_Z721C83C5(info, "phon") ? singleton(createElement("option", {
        value: "phon",
        children: "Phonetic",
    })) : empty(), delay(() => append(SharedCorpusInfo__HasAttribute_Z721C83C5(info, "orig") ? singleton(createElement("option", {
        value: "orig",
        children: "Original",
    })) : empty(), delay(() => (SharedCorpusInfo__HasAttribute_Z721C83C5(info, "lemma") ? singleton(createElement("option", {
        value: "lemma",
        children: "Lemmas",
    })) : empty())))))))))));
    const dropdown = ofArray([(patternInput = Helpers_extractClasses(ofArray([["className", "is-small"], ["className", "is-info"], ["value", ""], ["onChange", (ev) => {
        const attr = ev.target.value;
        if (attr !== "") {
            dispatch(new Msg(26, attr));
        }
    }], ["children", Interop_reactApi.Children.toArray(Array.from(selectOptions))]])), createElement("div", createObj(ofArray([["className", join(" ", cons("select", patternInput[0]))], (elems_1 = [createElement("select", createObj(patternInput[1]))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))), (props_9 = ofArray([["className", "is-left"], (elems_2 = [createElement("i", {
        className: "fa fa-chart-simple",
        style: {
            color: "#3e8ed0",
        },
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]), createElement("span", createObj(Helpers_combineClasses("icon", props_9))))]);
    const props_14 = ofArray([["className", "has-icons-left"], ["style", {
        marginBottom: 5,
    }], (elems_4 = (((SharedCorpusInfo__HasAttribute_Z721C83C5(info, "phon") ? true : SharedCorpusInfo__HasAttribute_Z721C83C5(info, "orig")) ? true : SharedCorpusInfo__HasAttribute_Z721C83C5(info, "lemma")) ? dropdown : singleton_1((props_12 = ofArray([["className", "is-small"], ["className", "is-outlined"], ["className", "is-info"], ["style", {
        marginTop: 5,
    }], ["title", "Show selection"], ["onClick", (_arg1) => {
        dispatch(new Msg(26, "word"));
    }], (elems_3 = [createElement("span", {
        children: ["Open in Voyant"],
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])]), createElement("button", createObj(Helpers_combineClasses("button", props_12)))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])]);
    voyantSelect = createElement("div", createObj(Helpers_combineClasses("control", props_14)));
    const menuItems = toList(delay(() => collect((item) => {
        if (item.tag === 0) {
            const category = item.fields[0];
            const isOpen = equals_1(category["Shared.Metadata.Category.get_Code"](), model.OpenMetadataCategoryCode);
            if (category instanceof Metadata_StringCategory) {
                return singleton(MetadataMenu_stringSelect(category, isOpen, model.Search.Params.MetadataSelection, model.FetchedMetadataValues, true, dispatch));
            }
            else if (category instanceof Metadata_NumberCategory) {
                return singleton(createElement(MetadataMenu_SelectOrInterval, {
                    category: category,
                    isOpen: isOpen,
                    mode: defaultArg(FSharpMap__TryFind(model.IntervalCategoryModes, category["Shared.Metadata.Category.get_Code"]()), new ListOrIntervalMode(0)),
                    metadataSelection: model.Search.Params.MetadataSelection,
                    fetchedMetadataValues: model.FetchedMetadataValues,
                    fetchedMinAndMax: model.FetchedMinAndMax,
                    isInSidebar: true,
                    dispatch: dispatch,
                }));
            }
            else if (category instanceof Metadata_LongTextCategory) {
                return singleton(MetadataMenu_freeTextSearch(category, dispatch));
            }
            else {
                throw (new Error(`Unhandled category: ${category}`));
                return empty();
            }
        }
        else {
            const startExpanded = !(item.fields[0].tag === 1);
            return singleton(createElement(MetadataMenu_Section, {
                startExpanded: startExpanded,
                title: item.fields[1],
                items: item.fields[2],
                openCategoryCode: model.OpenMetadataCategoryCode,
                intervalCategoryModes: model.IntervalCategoryModes,
                metadataSelection: model.Search.Params.MetadataSelection,
                fetchedMetadataValues: model.FetchedMetadataValues,
                fetchedMinAndMax: model.FetchedMinAndMax,
                dispatch: dispatch,
            }));
        }
    }, Corpus__get_MetadataMenu(model.Corpus))));
    let selectionButtons;
    const props_26 = ofArray([["style", {
        marginTop: 5,
    }], (elems_9 = toList(delay(() => {
        let props_19, elems_6, elms;
        return append(singleton((props_19 = ofArray([["className", "is-small"], ["className", "is-outlined"], ["className", "is-info"], ["title", "Show selection"], ["onClick", (_arg2) => {
            dispatch(new Msg(18));
        }], (elems_6 = [(elms = singleton_1(createElement("i", {
            className: join(" ", ["fa fa-binoculars"]),
        })), createElement("span", {
            className: "icon",
            children: Interop_reactApi.Children.toArray(Array.from(elms)),
        })), createElement("span", {
            children: ["Show"],
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])]), createElement("button", createObj(Helpers_combineClasses("button", props_19))))), delay(() => {
            let props_24, elems_8, elms_1;
            return append((Corpus__get_SharedInfo(model.Corpus).GeoMapConfig != null) ? singleton((props_24 = ofArray([["className", "is-small"], ["className", "is-outlined"], ["className", "is-info"], ["title", "Show map"], ["onClick", (_arg3) => {
                dispatch(new Msg(23));
            }], (elems_8 = [(elms_1 = singleton_1(createElement("i", {
                className: join(" ", ["fa fa-globe"]),
            })), createElement("span", {
                className: "icon",
                children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
            })), createElement("span", {
                children: ["Map"],
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))])]), createElement("button", createObj(Helpers_combineClasses("button", props_24))))) : empty(), delay(() => (contains_1(new ExternalTool(2), Corpus__get_SharedInfo(model.Corpus).ExternalTools, {
                Equals: equals_1,
                GetHashCode: safeHash,
            }) ? singleton(voyantSelect) : empty())));
        }));
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])]);
    selectionButtons = createElement("div", createObj(Helpers_combineClasses("buttons", props_26)));
    const children_3 = toList(delay(() => {
        let matchValue, config, matchValue_1, key_55, matchValue_2, coords, metadata;
        return append(model.IsMetadataGeoMapOpen ? ((matchValue = Corpus__get_SharedInfo(model.Corpus).GeoMapConfig, (matchValue == null) ? singleton(null) : ((config = matchValue, (matchValue_1 = Corpus__get_SharedInfo(model.Corpus).GoogleMapsApiKey, (matchValue_1 == null) ? (((() => {
            throw (new Error("No Google Maps API key provided! Set it in the environment variable GOOGLE_MAPS_API_KEY."));
        })(), empty())) : ((key_55 = matchValue_1, (matchValue_2 = Corpus__get_SharedInfo(model.Corpus).GeoCoordinates, (matchValue_2 == null) ? (((() => {
            throw (new Error("No geographical coordinates provided!"));
        })(), empty())) : ((coords = matchValue_2, (metadata = toArray_1(delay(() => map((informants) => toArray_1(delay(() => map((informantCategory) => (((informantCategory === "") ? true : (informantCategory === "NULL")) ? "null" : informantCategory), informants))), model.FetchedTextMetadata))), singleton(createElement(MetadataMenu_MetadataGeoMapModal, {
            googleMapsApiKey: key_55,
            geoCoords: coords,
            geoMapConfig: config,
            metadata: metadata,
            allCategories: Corpus__get_MetadataQuickView(model.Corpus),
            dispatch: dispatch,
        }))))))))))))) : empty(), delay(() => {
            let properties_22, elems_10;
            return append(singleton(createElement("div", createObj(ofArray([(properties_22 = ofArray([["width", 200], ["paddingLeft", 0.75 + "em"], ["marginBottom", 0.75 + "rem"]]), ["style", createObj(properties_22)]), (elems_10 = [textAndTokenCountText(model), selectionButtons], ["children", Interop_reactApi.Children.toArray(Array.from(elems_10))])])))), delay(() => append(model.IsSelectionTableOpen ? singleton(createElement(MetadataMenu_SelectionTablePopup, {
                model: model,
                loadedCorpusDispatch: loadedCorpusDispatch,
                dispatch: dispatch,
            })) : empty(), delay(() => {
                let props_30, elems_12;
                return singleton((props_30 = ofArray([["style", {
                    width: 200,
                    overflowX: "hidden",
                }], ["onClick", (e) => {
                    e.stopPropagation();
                }], (elems_12 = [createElement("ul", {
                    className: "menu-list",
                    children: Interop_reactApi.Children.toArray(Array.from(menuItems)),
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_12))])]), createElement("aside", createObj(Helpers_combineClasses("menu", props_30)))));
            }))));
        }));
    }));
    return createElement("span", {
        children: Interop_reactApi.Children.toArray(Array.from(children_3)),
    });
}

